import React from 'react';

import { PercentageCell } from './cellComponentStyle';

const Percentage = ({ value }: { value: number }) => {
  return <PercentageCell isZero={value === 0}>{value}%</PercentageCell>;
};

export default Percentage;
